function isImageFile(file: File) {
  return file.type.startsWith("image/");
}

async function compressImageFile(file: File) {
  return new Promise<File>((resolve, reject) => {
    const image = new Image();
    const objectUrl = URL.createObjectURL(file);

    image.onload = () => {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      canvas.width = image.width / 2;
      canvas.height = image.height / 2;

      if (!context) {
        URL.revokeObjectURL(objectUrl);
        reject(new Error("Falha ao preparar a imagem para upload"));
        return;
      }

      context.drawImage(image, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(
        (blob) => {
          URL.revokeObjectURL(objectUrl);

          if (!blob) {
            reject(new Error("Falha na conversao da imagem, tente novamente"));
            return;
          }

          resolve(
            new File([blob], "compressed.jpg", {
              type: "image/jpeg",
              lastModified: Date.now(),
            })
          );
        },
        "image/jpeg",
        0.5
      );
    };

    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Falha ao carregar a imagem, tente novamente"));
    };

    image.src = objectUrl;
  });
}

export async function prepareFileForUpload(file: File) {
  if (!isImageFile(file)) {
    return file;
  }

  return compressImageFile(file);
}

export function getFileExtension(fileNameOrUrl?: string) {
  if (!fileNameOrUrl) {
    return "";
  }

  const cleanName = fileNameOrUrl.split("?")[0];
  const parts = cleanName.split(".");
  return parts.length > 1 ? parts.pop()?.toLowerCase() || "" : "";
}

export function isPdfFile(fileNameOrUrl?: string, mimeType?: string) {
  if (mimeType === "application/pdf") {
    return true;
  }

  return getFileExtension(fileNameOrUrl) === "pdf";
}

export function isImageLikeFile(fileNameOrUrl?: string, mimeType?: string) {
  if (mimeType?.startsWith("image/")) {
    return true;
  }

  return ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"].includes(
    getFileExtension(fileNameOrUrl)
  );
}
